/**
 * Format a date for display across the app: DD/MM/YY hh:mm (24h).
 * @param {string|Date} date - ISO string or Date instance
 * @returns {string} Formatted string or empty string if invalid
 */
export function formatDateTime(date) {
  if (date == null || date === '') return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = String(d.getFullYear()).slice(-2);
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
